import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const isLogin = localStorage.getItem('token');
  if (isLogin) {
    return <Navigate to="/" />;
  }
  return children;
};

PublicRoute.propTypes = {
  children: PropTypes.node
};

export default PublicRoute;
